import React, { useState, useEffect } from 'react';
import { Common } from '../../../consts/Common';
import { RPCFactory } from '../../../utils/RequestUtil';
import { Button, Dialog, Icon, PopOver } from '@tencent/spaui';
import { payGuidePrefix as prefix } from '../../../consts/prefix';
import { withWujiPayList } from './withWujiPayList';
const { OverlayTrigger } = PopOver;
const PopoverInternal = PopOver.PopOver;

const PayComponentInner = (props) => {
  const { value, className } = props;
  const [payData, setPayData] = useState({});
  const [payDialogSubmitLabel, setLabel] = useState('');
  const [showStatisticDialog, setShowStatisticDialog] = useState(false);
  const [showPayTip, setShowPayTip] = useState(false);
  const [showPopover, setShowPopover] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowPopover(true);
    }, 600);
  }, []);

  useEffect(() => {
    if (props.monthList.length == 0 || props.monthList[0].value == '2022-02') {
      return;
    }
    const key = prefix + props.monthList[0].value + window.pageProps.uid;
    if (localStorage.getItem(key) !== 'showed') {
      setShowPayTip(true);
    }
  }, [props.monthList]);
  const onHandleGetPayDetail = (date) => {
    RPCFactory.pay
      .getStatistic(date)
      .done((data) => {
        if (data) {
          setShowStatisticDialog(true);
          setPayData({
            seletedPayMonth: date,
            payNum: data.leadsNumber,
            payValue: data.totalAmount,
            shouldPayAmount: data.shouldPayAmount,
            actualPayAmount: data.actualPayAmount,
            noPayAccountIds: data.noPayAccountIds,
          });
          if (data.leadsNumber) {
            setLabel('下载明细');
          } else {
            setLabel('确定');
          }
        }
      })
      .fail((ret, msg) => {
        alert(`获取赔付数据失败: ${msg}`);
      });
  };
  const onCloseDialog = () => {
    setShowStatisticDialog(false);
  };
  const onDownloadPayDetail = () => {
    window.location.href = `${Common.LEADS_PAY_RECORD_DOWNLOAD}?accountId=${window.pageProps.uid}&time=${payData.seletedPayMonth}`;
  };
  const onClickMorePayInfo = (e) => {
    e.preventDefault();
    window.location.href = '#/payDetailPage';
  };
  const onDisabelTip = () => {
    setShowPayTip(false);
    const key = prefix + props.monthList[0].value + window.pageProps.uid;
    localStorage.setItem(key, 'showed');
  };
  const dropDownContent = (
    <li className={`${className} spaui-topnav-drop`}>
      <a className="nav-link" href="#">
        <i className="spaui-icon icon-pay-dark-highlight"></i>
      </a>
      <ul className="spaui-topnav-menu pay-card">
        <span className="pay-header new-pay">最新赔付：</span>
        <p
          className="pay-month"
          onClick={() => onHandleGetPayDetail(props.monthList.length == 0 ? '2022-02' : props.monthList[0].value)}
        >
          {`${props.monthList.length == 0 ? '2022年2月' : props.monthList[0].label}赔付明细`}
        </p>
        <p className="pay-month" onClick={onClickMorePayInfo}>
          更多赔付明细
        </p>
        <div className="pay-header pay-condition">标签含义：</div>
        <div className="pay-detail">
          参与赔付：无效赔付政策参与对象：推广计划设置的出价方式为OCPC、OCPM，第一优化目标为表单预约／综合线索收集／有效线索收集，线索来源包含蹊径落地页、微信原生推广页、广告附加创意组件、讯达小程序、互动落地页，线索类型为表单预约-提交表单的线索。
        </div>
        <div className="pay-detail" style={{ margin: '10px 0px 0px 0px' }}>
          确认赔付：线索状态标注为无效-未接通或开启智能外呼接通状态为未接通的线索，经过系统智能实时验证后确认是空号／停机／关机的线索会被打上确认赔付标签。
        </div>
        <div className="pay-detail" style={{ margin: '10px 0px 0px 0px', color: 'red' }}>
          注：当且仅当该账户当月48小时内线索标记率>=50%的前提下，确认赔付标签才等于真实赔付。（重复注册线索不参与赔付无需标记）
        </div>
        <div className="pay-header pay-delever">赔付金发放：</div>
        <div className="pay-detail">每月赔付金额将在下月中旬以补偿虚拟金的形式发放至对应账户中。</div>
        <div className="pay-detail">具体赔付金额明细请点击上方赔付明细按钮进行查看和下载。</div>
        <div className="pay-header pay-more">其他：</div>
        <div className="pay-detail">微信子客赔付明细可在直客账号中查看，但赔付金额将发放到子客自身账号中。</div>
        <div className="pay-header">政策文档链接：</div>
        <a
          className="pay-detail"
          href="https://docs.qq.com/doc/DWFpOb3h0bUljS0RD"
          target="_blank"
          rel="noreferrer"
          style={{ color: '#296BEF' }}
        >
          https://docs.qq.com/doc/DWFpOb3h0bUljS0RD
        </a>
      </ul>
    </li>
  );
  const showSpecialNoPayReasonForADQ =
    !!payData.noPayAccountIds && !!payData.noPayAccountIds.length && !window.pageProps.isMpAdvertiser; // ADQ账户存在确认赔付标签但是未赔付情况
  const showSpecialNoPayReasonForMP =
    !!payData.payValue &&
    payData.noPayAccountIds &&
    !!payData.noPayAccountIds.length &&
    window.pageProps.isMpAdvertiser; // MP账户存在确认赔付标签但是未赔付的部分账户
  const showCommonNoPayReason = !showSpecialNoPayReasonForADQ && !showSpecialNoPayReasonForMP;
  const statisticDialog = (
    <Dialog
      className="pay-modal-dialog"
      show={showStatisticDialog}
      type="normal"
      style={{ width: '450px' }}
      onClose={onCloseDialog}
      onCancel={onCloseDialog}
      onSubmit={payData.payValue || payData.shouldPayAmount ? onDownloadPayDetail : onCloseDialog}
      submitLabel={payDialogSubmitLabel}
      cancelButton={!!payData.payValue || !!payData.shouldPayAmount}
    >
      <div className="pay-content">
        {payData.payNum ? (
          <div className="pay-statistic">
            <div className="pay-header">本账号本月赔付情况如下：</div>
            <p>赔付线索数量：{payData.payNum}条；</p>
            {payData.payValue && <p>赔付金额为：{payData.payValue}元。</p>}
            {payData.shouldPayAmount && <p>应赔付金额为：{payData.shouldPayAmount}元。</p>}
            {payData.shouldPayAmount && <p>实际赔付金额为：{payData.actualPayAmount}元。</p>}
            {payData.shouldPayAmount !== payData.actualPayAmount && (
              <div className="top-margin" style={{ margin: '10px 0px 0px 0px' }}>
                <div className="pay-header">应赔金额和实际赔付金额不一致的原因：</div>
                <p>
                  系统于9月中旬对本账号重复发放了两次8月无效线索赔付款，因此本月以及后续月份将在应赔付金额的基础上扣除8月重复发放款项后进行实际赔付。对此给您带来的不便我们深感抱歉，详见顶部导航栏右上方
                  消息中心-政策通知专栏进行查阅。
                </p>
              </div>
            )}
            {showSpecialNoPayReasonForMP && (
              <div>
                账号
                {payData.noPayAccountIds.map((accountid, index) =>
                  index < payData.noPayAccountIds.length - 1 ? (
                    <span>
                      {accountid}
                      {'、'}
                    </span>
                  ) : (
                    <span>{accountid}</span>
                  ),
                )}
                因未满足政策要求48h内标注率大于等于50%，导致“确认赔付”标签失效，不进行真实赔付。
              </div>
            )}
          </div>
        ) : (
          <div className="pay-statistic">
            <Icon className="spaui-pay-warning" name="spaui-icon-big-remind" />
            {showSpecialNoPayReasonForADQ && (
              <div>
                本账号该月暂无可赔付线索，具体原因为未满足政策要求48h内标注率{'>='}
                50%，导致“确认赔付”标签失效，不进行真实赔付。
              </div>
            )}
            {showCommonNoPayReason && (
              <div>
                <div className="pay-summary">本账号该月暂无可赔付线索，具体原因可能有以下几种情况：</div>
                <ul>
                  <li>
                    1、当月“参与赔付”线索48小时内标注数（线索状态=已转化、无效）／当月“参与赔付”线索总数{'<'}
                    50%；（重复注册线索不用重复标记）
                  </li>
                  <li>
                    2、账户虽满足48小时内标记率{'>='}
                    50%，但不存在线索状态标注结果未为无效-未接通或者接通状态为未接通的线索。
                  </li>
                  <li>
                    3、系统对线索状态标注结果未为无效-未接通或者接通状态为未接通的线索进行智能验证后，不存在空号、停机、关机线索。
                  </li>
                  <li>
                    4、若线索上报账号（归属账号）和推广账号不一致，赔付明细和金额请在上报账号（归属账号）查看和下载。
                  </li>
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
    </Dialog>
  );
  return showPayTip ? (
    <OverlayTrigger
      show={showPopover}
      overlay={
        <PopoverInternal className="dark a-guide-popover popover-right" showDelayTime={1000}>
          <div className="spaui-popover-body">
            <p>{`${props.monthList[0].label}无效赔付明细已产出。`}</p>
          </div>
          <div className="spaui-popover-footer">
            <Button className="pay-notice-confirm" bsSize="small" bsStyle="primary" onClick={onDisabelTip}>
              我知道了
            </Button>
          </div>
        </PopoverInternal>
      }
    >
      {dropDownContent}
      {statisticDialog}
    </OverlayTrigger>
  ) : (
    <React.Fragment>
      {dropDownContent}
      {statisticDialog}
    </React.Fragment>
  );
};

export const PayComponent = React.memo(withWujiPayList(PayComponentInner));
